import { render } from "./Index.vue?vue&type=template&id=562430ee&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-562430ee"

export default script